<template>
  <div
    class="story-image-placeholder-container d-flex align-center justify-center pa-5"
  >
    <img class="icon" src="@/assets/icons/add_image.svg" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    height: { type: String, default: "11.2rem" },
    width: { type: String, default: "7rem" }, 
    center: { type: Boolean, default: true },
  }
};
</script>

<style lang="scss" scoped>
.story-image-placeholder-container {
  width: 100%;
  height: 100%;
}

.icon {
  width: 24px;
  height: 24px;
}
</style>